import { render, staticRenderFns } from "./SimTransferList.vue?vue&type=template&id=d4487358&scoped=true"
import script from "./SimTransferList.vue?vue&type=script&lang=js"
export * from "./SimTransferList.vue?vue&type=script&lang=js"
import style0 from "./SimTransferList.vue?vue&type=style&index=0&id=d4487358&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4487358",
  null
  
)

export default component.exports